import React from 'react';
import { Booking } from '../types/booking.types';

interface CustomerDetailsCardProps {
  booking: Booking;
}

const CustomerDetailsCard: React.FC<CustomerDetailsCardProps> = ({ booking }) => {
  return (
    <div className="bg-blue-50 rounded-lg p-4 border border-blue-100">
      <h3 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
        Customer Details
      </h3>
      <div className="space-y-2 text-sm">
        <p className="text-gray-700">
          <span className="font-medium">Name:</span> {booking.user_name}
        </p>
        <p className="text-gray-700">
          <span className="font-medium">Email:</span> {booking.user_email}
        </p>
        <p className="text-gray-700">
          <span className="font-medium">Phone:</span> {booking.mobile_no}
        </p>
      </div>
    </div>
  );
};

export default CustomerDetailsCard;
